var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCollasped = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 1.33317C4.3193 1.33317 1.33464 4.31784 1.33464 7.99984C1.33464 11.6818 4.3193 14.6665 8.0013 14.6665C11.6833 14.6665 14.668 11.6818 14.668 7.99984C14.668 4.31784 11.6833 1.33317 8.0013 1.33317Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3516 8.83984L7.99823 6.49318L5.6449 8.83984",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCollasped, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/collasped.e1624ab4.svg";
export { ForwardRef as ReactComponent };